import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteNotificationsByIdRequest = {
	id: number;
};

export const deleteNotificationsById = createDeleteEndpoint<DeleteNotificationsByIdRequest>(
	(request) => `/api/v3/notifications/${request?.id}`
);
